__webpack_require__.p = "https://wand.afi.dev/";